import React from 'react'

import Anchor from 'component/Anchor'
import Section from 'component/Section'
import SectionHeader from 'component/SectionHeader'
import { StaticImage } from 'gatsby-plugin-image'

const AurumNaMidia = () => {
	return (
		<Section>
			<SectionHeader
				titleHeadingLevel="2"
				titleHeadingSize="4"
				title="Aurum na mídia"
			/>
			<ul className="igmGrid">
				<li>
					<Anchor
						target="blank"
						href="https://exame.com/liderando-bussola/bussola-cia-aurum-projeta-faturamento-de-r-62-milhoes/"
					>
						<StaticImage
							src="../../../media-library/companys/logo-exame.svg"
							alt="Exame"
							placeholder="blurred"
							width={181}
							height={56}
							breakpoints={[475, 650, 750, 1199]}
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</Anchor>
				</li>
				<li>
					<Anchor
						target="blank"
						href="https://www.jota.info/artigos/gestao-dos-escritorios-de-advocacia-na-era-digital-07042017"
					>
						<StaticImage
							src="../../../media-library/companys/jota.webp"
							alt="Jota"
							width={246}
							height={76}
							breakpoints={[475, 650, 750, 1199]}
							placeholder="blurred"
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</Anchor>
				</li>
				<li>
					<Anchor
						target="blank"
						href="https://pipelinevalor.globo.com/startups/noticia/braco-da-canadense-constellation-chega-a-12-aquisicoes-no-brasil.ghtml"
					>
						<StaticImage
							src="../../../media-library/companys/logo-valor-economico.svg"
							alt="Valor Economico"
							width={181}
							height={56}
							breakpoints={[475, 650, 750, 1199]}
							placeholder="blurred"
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</Anchor>
				</li>
				<li>
					<Anchor
						target="blank"
						href="http://www.migalhas.com.br/Quentes/17,MI263366,11049-Pesquisa+Aurum+mostra+perfil+do+advogado+moderno"
					>
						<StaticImage
							src="../../../media-library/companys/migalhas.webp"
							alt="Migalhas"
							width={246}
							height={76}
							breakpoints={[475, 650, 750, 1199]}
							placeholder="blurred"
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</Anchor>
				</li>
				<li>
					<Anchor
						target="blank"
						href="https://www.terra.com.br/noticias/dino/desenvolvedora-de-software-juridico-anuncia-aporte-de-r-16-milhao,8c0e7dfc6e9e70b5ff08c1458d6bcc069j6ui0nr.html"
					>
						<StaticImage
							src="../../../media-library/companys/terra.webp"
							alt="Terra"
							width={246}
							height={76}
							breakpoints={[475, 650, 750, 1199]}
							placeholder="blurred"
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</Anchor>
				</li>
			</ul>
		</Section>
	)
}

export default AurumNaMidia
